(function(){
  var cur=document.currentScript||document.querySelector('script[src*="velya-gift.js"]');
  if(cur&&cur.src){var s=document.createElement('script');s.src=cur.src.replace('velya-gift.js','velya-fx.js');s.defer=true;document.body.appendChild(s);}
  var g=document.getElementById('gift'); if(!g) return;
  var btn=document.querySelector('[data-gift-open]'), form=g.querySelector('form');
  var s1=g.querySelector('[data-gift-step1]'), s2=g.querySelector('[data-gift-step2]'), codeEl=g.querySelector('[data-gift-code]');
  var code=g.dataset.code, KEY='velya_gift';
  var get=function(){try{return localStorage.getItem(KEY)}catch(e){return null}};
  var set=function(v){try{localStorage.setItem(KEY,v)}catch(e){}};
  var open=function(){g.classList.add('is-open');g.setAttribute('aria-hidden','false')};
  var close=function(){g.classList.remove('is-open');g.setAttribute('aria-hidden','true');if(!get())set('seen')};
  var showCode=function(){s1.hidden=true;s2.hidden=false;codeEl.textContent=code;fetch('/discount/'+encodeURIComponent(code)).catch(function(){})};
  if(btn){btn.hidden=false;btn.addEventListener('click',function(){if(get()==='done')showCode();open()})}
  Array.prototype.forEach.call(g.querySelectorAll('[data-gift-close]'),function(b){b.addEventListener('click',close)});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close()});
  if(form)form.addEventListener('submit',function(e){
    e.preventDefault();
    fetch(form.action,{method:'POST',body:new FormData(form)}).then(function(){set('done');showCode()}).catch(function(){set('done');showCode()});
  });
  if(!get()) setTimeout(open,15000);
})();
